// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.

import api from "@/api/auth.js";

var storage = window.localStorage;

export default {
  state: {
    user: storage.getItem('user') || "",
    token: storage.getItem("user-token") || "",
    status: 'refresh',
    validRequestID: false,
  },
  getters: {
    isAuthenticated(state) {
      if (state.status === 'refresh' && state.token) {
        api.refreshToken(state.token)
        return true;
      }

      if (state.status === 'success')
        return true;

      return false;

    },
    isValidRequestID(state) {
      return state.validRequestID;
    },
    getCurrentUser(state) {
      return state.user;
    }
  },
  mutations: {
    setAuthenticated(state, {credentials, token}) {
      storage.setItem('user-token', token);
      storage.setItem('user', credentials.username);
      state.token = token;
      state.user = credentials.username;
      state.status = 'success';
    },
    clearAuthentication(state) {
      storage.removeItem('user-token');
      storage.removeItem('user');
      state.token = '';
      state.user = '';
      state.status = 'logout';
    },
    setValidRequestID(state, flag) {
      state.validRequestID = flag;
    }
  },
  actions: {
    async authenticate({commit}, credentials) {
      try {
        let token = await api.login(credentials);
        if (token != false) {
          commit('setAuthenticated', {credentials, token});
        }
      }catch(e) {
        commit('clearAuthentication');
      }
    },
    async logout({commit}) {
      let res = await api.logout();
      if (res == true) {
        commit('clearAuthentication');
      }
    },
    async submitPasswordResetRequest(_, email) {
      try {
        await api.sendPasswordResetRequest(email);
      } catch (_) {
        return;
      }
    },
    async resetPassword(_, {id, password}) {
      let ok = await api.resetPassword(id, password);
      return ok;
    },
    async validateRequestID({commit}, requestID) {
      try {
        let ok = await api.validateRequestID(requestID)
        commit('setValidRequestID', ok);
      } catch (_) {
        commit('setValidRequestID', false);
      }
    },
    async changePassword(_, data) {
      await api.changePassword(data)
    }
  },
}
